export function ValidatePassword(password, passwordConfirm) {
    if (!password || (passwordConfirm !== undefined && !passwordConfirm)) {
        return null;
    }

    if (passwordConfirm !== undefined && password !== passwordConfirm) {
        return "비밀번호가 일치하지 않습니다.";
    }

    const missing = [];

    if (password.length < 8) {
        missing.push("8자 이상");
    }

    // Lowercase Letters
    if (!/[a-z]/.test(password)) {
        missing.push("소문자");
    }

    // Capitalized Letters
    if (!/[A-Z]/.test(password)) {
        missing.push("대문자");
    }

    // Numbers
    if (!/\d/.test(password)) {
        missing.push("숫자");
    }

    // Special Characters
    // if (!/[^\da-zA-Z]/.test(password)) {
    //     missing.push("특수문자");
    // }

    if (missing.length > 0) {
        return `비밀번호에 다음이 포함되어야 합니다:
        ${missing.join(", ")}`;
    }

    return null;
}